import React, { useState, useEffect } from "react";
import { db, storage } from "../firebase-config";
import {
    addDoc,
  collection,
  onSnapshot,
  orderBy,
  query,
  Timestamp,
} from "firebase/firestore";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { toast } from "react-toastify";
import DeleteProject from "../pages/DeleteProject";

function Blog() {
  const [tags, setTags] = useState([{tag: ""}]);
  const [ticks, setTicks] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    image: "",
    tags: "",
    ticked: "",
    createdAt: Timestamp.now().toDate().toLocaleDateString()
  });
  const [progress, setProgress] = useState(0);
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const handleImageChange = (e) => {
    setFormData({ ...formData, image: e.target.files[0] });
  };
  // const handleClickTags = (e) => {
  //   setFormData({...formData, tags: ""})
  // }
  
  const handlePublish = () => {
    if (!formData.title || !formData.description || !formData.image) {
      alert("Please fill all the fields");
      return;
    }
    const storageRef = ref(
      storage,
      `/images/${Date.now()}${formData.image.name}`
    );
    const uploadImage = uploadBytesResumable(storageRef, formData.image);
    uploadImage.on("state_changed", (snapshot) => {
      const progessPercent = Math.round(
        (snapshot.bytesTransferred / snapshot.totalBytes) * 100
      );
      setProgress(progessPercent);
    }, (err)=>{
        console.log(err)
    }, ()=>{
        setFormData({
            title: "",
            description: "",
            image: "",
            tags: "" 
        });
        getDownloadURL(uploadImage.snapshot.ref).then((url)=>{
            const blogRef = collection(db, "blog");
            addDoc(blogRef, {
                title: formData.title,
                description: formData.description,
                imageUrl: url,
                createdAt: Timestamp.now().toDate(),
                tags: formData.tags
            }).then(()=>{
                toast("Blog added successfully", {type: "success"});
                setProgress(0);
            }).catch(err => {
                toast("Error adding blog", {type: "error"});
            })
        })
    });
  };

  //Test
  const handleClickTag = () => {
    setTags([...tags, {tag: ""}])
  }
  const handleChangeTag = (e, i) => {
    const {name, value} = e.target
    const onchangeVal = [...tags]
    onchangeVal[i][name] = value
    setTags(onchangeVal)
  }
  const handleDelete = (i) => {
    const deleteVal = [...tags]
    deleteVal.splice(i, 1)
    setTags(deleteVal)
  }

  function handleKeyDown(e){
    if(e.key !== 'Enter') return
    const value = e.target.value
    if(!value.trim()) return
    setTicks([...ticks, value])
    e.target.value = ''
  }
  function removeTick(index){
    setTicks(ticks.filter((el, i) => i !== index))
  }
  //Test
  

  useEffect(() => {
    const blogRef = collection(db, "blog");
    const q = query(blogRef, orderBy("createdAt", "desc"));
    onSnapshot(q, (snapshot) => {
      const blogs = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setBlogs(blogs);
      //console.log(blogs);
    });
  }, []);
  return (
    <div className="fx">
      <div className="cont">
        {blogs.length === 0 ? (
          <p>No blog found</p>
        ) : (
          blogs.map(({ id, title, description, imageUrl, createdAt, tags }) => (
            <div className="c" key={id}>
              <p>{title}{console.log(imageUrl)}</p>
              <p>{description}</p>
              <p>{createdAt.toDate().toLocaleDateString()}</p>
              <p>{tags}</p>
              <img
                src={imageUrl}
                alt="Image"
                style={{ height: 100, width: 100 }}
              />
              <DeleteProject id={id} imageUrl={imageUrl}/>
            </div>
          ))
        )}
      </div>
      <div className="frm">
        <h2>Create Blog</h2>
        <label htmlFor="">Title</label>
        <input
          type="text"
          name="title"
          className="fr"
          value={formData.title}
          onChange={(e) => handleChange(e)}
        />
        <label htmlFor="">Description</label>
        <textarea
          name="description"
          className="fr"
          value={formData.description}
          onChange={(e) => handleChange(e)}
        />
        <label htmlFor="">Tags</label>
        <input
          type="text"
          name="tags"
          className="fr"
          value={formData.tags}
          onChange={(e) => handleChange(e)}
        />
        <label htmlFor="">Image</label>
        <input
          type="file"
          name="image"
          accept="image/*"
          className="fr"
          onChange={(e) => handleImageChange(e)}
        />
        
        <div style={{marginBottom: "20px", marginTop: "20px"}}>
          {/* <label htmlFor="">Tags</label>
          <button onClick={handleClickTags}>Add</button>
          <input name="tags" onChange={(e) => handleChange(e)}/> */}
          {/* {formData.map((result) => {
            <div key={result.id}><input name="tags" value={result.tags} onChange={(e) => handleChange(e)}/></div>
            console.log(result.tags)
          })} */}
          <label htmlFor="">Object </label>
          {JSON.stringify(formData)}
          {/* {console.log("FormData", Object.entries(formData))} */}
        </div>
        
        {progress === 0 ? null : (
            <div className="prog" style={{width: `${progress}%`}}>{`uploading image ${progress}%`}</div>
        )}
        <label htmlFor="">Button</label>    
        <button className="b" onClick={handlePublish}>
          Publish
        </button>

        <div style={{marginTop: "20px"}}>
          <button onClick={handleClickTag}>Add</button>
          {
            tags.map((val, i)=>
            <div key={val.id}>
              <input name="tag" value={val.tag} onChange={(e)=>handleChangeTag(e,i)} />
              <button onClick={()=>handleDelete(i)}>Delete</button>
            </div>
          )
          }
          {JSON.stringify(tags)}
          <div className="tagging" style={{"border":"2px solid #ddd", "padding": "5px"}}>
            {ticks.map((tick, index)=>(
              <div key={index} style={{"background":"#ddd", "color":"#333", "padding":"5px", "display":"inline-block"}} className="tag">
                <span className="cont">{tick}</span>
                <span className="crossTick" onClick={() => removeTick(index)}> X</span>
              </div>
            ))}
            <input onKeyDown={handleKeyDown} type="text" placeholder="Type..." />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Blog;
